import React, { useState, useEffect } from 'react';
import validationAuth from '../../../validationAuth';
import {
    Box, Typography, Select, InputLabel, MenuItem, FormControl,
    Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, TablePagination, Dialog, DialogActions, DialogContent, DialogTitle, Divider,
    IconButton, Pagination, Stepper, Step, StepLabel, StepContent, Alert, FormHelperText,
    useMediaQuery, useTheme, Card, CardContent, Chip, Stack, Collapse, TextField
} from '@mui/material';
import Input from '@mui/material/Input';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import PersonIcon from '@mui/icons-material/Person';
import EditIcon from '@mui/icons-material/Edit';
import axios from 'axios';
import * as common from "../../../commons/common";
import SearchArea from '../../../components/managerPage/searchArea';
import AlertForConfirm from '../../../components/alertForConfirm';

const MemberManagement = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    // 모바일 검색폼 토글 상태 추가
    const [isSearchOpen, setIsSearchOpen] = useState(false);

    const [memberList, setMemberList] = useState({}); //전체 사용자 리스트
    const [roleList, setRoleList] = useState([]); // 전체 권한 리스트
    const [deptList, setDeptList] = useState([]); //전체 부서 리스트
    const [positionList, setPositionList] = useState([]); // 전체 직위 리스트
    //사용자 조직 책임자인지 여부
    const orgPosition = [{ position: '0', positionNm: '일반' }, { position: '1', positionNm: '관리본부(Tier1) 책임자' }, { position: '2', positionNm: '관리부서(Tier2) 책임자' }, { position: '3', positionNm: '팀(Tier3) 책임자' },];

    const [selectedMemberId, setSelectedMemberId] = useState(null); // 사용자 선택 조회
    const [detailMemberInfo, setDetailMemberInfo] = useState({
        memberId: '',
        memberNm: '',
        topDeptId: '',
        topDeptNm: '',
        midDeptId: '',
        midDeptNm: '',
        botDeptId: '',
        botDeptNm: '',
        lastDeptLevel: '',
        lastDeptId: '',
        role: '',
        roleNm: '',
        orgPosition: '', // 부서 책임자
        phone: '',
        email: '',
        position: '',
        imgSrc: '',
    }); //사용자 상세정보

    const [registerOpen, setRegisterOpen] = useState(false); // 신규 사용자 정보등록 모달 open
    const [detailOpen, setDetailOpen] = useState(false); // 상세정보 모달 open

    const [activeStep, setActiveStep] = useState(0); //신규 사용자 정보등록 모달 form step
    const [isPwInitAlertOpen, setIsPwInitAlertOpen] = useState(false); //비밀번호 초기화 alert
    const [isMemDelAlertOpen, setIsMemDelAlertOpen] = useState(false); //사용자 삭제 alert

    const [error, setError] = useState(''); //form 유효성 error

    const [searchRole, setSearchRole] = useState(''); // 검색 조건_역할(권한)
    const [searchName, setSearchName] = useState(''); // 검색 조건_사용자명
    const [isSave, setIsSave] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalElements, setTotalElements] = useState(0);

    const [searchParams, setSearchParams] = useState({
        role: '',
        deptId: '',
        memberNm: '',
        teamId: '',
        pageSize: '',
        pageNumber: '',
    });

    const token = localStorage.getItem('access_token');
    const positionComMstrId = 'CM1';

    useEffect(() => { //role 리스트 불러오기
        const fetchRoleData = async () => {
            try {
                const response = await axios.get(`${common.getApiUrl()}/common/role`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                });

                if (response.data) {
                    const fetchedItems = response.data.map((role) => ({
                        value: role.code,
                        label: role.title,
                    }));
                    fetchedItems.unshift({ value: ' ', label: '전체' });
                    setRoleList(fetchedItems)
                }
            } catch (error) {
                console.error("데이터를 가져오는 데 실패했습니다:", error);
            }
        }
        fetchRoleData();
    }, [])

    useEffect(() => { //전체부서 리스트 불러오기. 이후 depthLevel로 구분
        const fetchDeptData = async () => {
            try {
                const response = await axios.get(`${common.getApiUrl()}/admin/dept`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                });

                if (response.data) {
                    const fetchedList = response.data.map(dept => ({
                        ...dept,
                        deptId: String(dept.deptId),
                    }));

                    setDeptList(fetchedList);
                }

            } catch (error) {
                console.error("데이터를 가져오는 데 실패했습니다:", error);
            }
        }
        fetchDeptData();
    }, [])

    useEffect(() => { //직위 리스트 불러오기
        const fetchPositionData = async () => {
            try {
                const response = await axios.get(`${common.getApiUrl()}/admin/com-dtl`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    params: {
                        comMstrId: positionComMstrId,
                    },
                });

                if (response.data) {
                    const item = response.data
                    item.unshift({ comDtlId: '0', comDtlNm: '없음' });
                    setPositionList(item)
                }
            } catch (error) {
                console.error("데이터를 가져오는 데 실패했습니다:", error);
            }
        }
        fetchPositionData();
    }, [])

    useEffect(() => {
        fetchData();
    }, [isSave, isSearch, page, rowsPerPage]);

    //사용자 리스트 불러오기
    const fetchData = async () => {
        try {
            const params = {
                role: searchParams.role,
                deptId: searchParams.deptId,
                memberNm: searchParams.memberNm,
                teamId: searchParams.teamId,
                page: page,
                pageSize: rowsPerPage,
            };

            const response = await axios.get(`${common.getApiUrl()}/admin/member`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                params,
            });

            if (response.data && Array.isArray(response.data.content)) {
                let fetchedMembers = response.data.content.map((item) => ({
                    roleNm: item.roleNm || '',
                    memberId: item.memberId || '',
                    memberNm: item.memberNm || '',
                    email: item.email || '',
                    phone: item.phone || '',
                    deptNm: item.deptNm || '',
                }));

                setTotalElements(response.data.totalElements); //총 데이터 갯수

                // 초기가입자 맨 위로 보여주기
                const initialMembers = fetchedMembers.filter(member => member.roleNm === '초기사용자');
                if (initialMembers.length > 0) {
                    initialMembers.forEach(initialMember => {
                        fetchedMembers = fetchedMembers.filter(member => member.memberId !== initialMember.memberId);
                        fetchedMembers.unshift(initialMember);
                    });
                }

                setMemberList(fetchedMembers);
                setIsSave(false);
                setIsSearch(false);
            }
        } catch (error) {
            console.error("데이터를 가져오는 데 실패했습니다:", error);
        }
    };

    const handleSearchChanges = (name, value) => {
        if (name === 'role') {
            setSearchRole(value.trim());
            setSearchParams(prevState => ({
                ...prevState,
                [name]: value.trim(),
            }));
        } else if (name === 'memberNm') {
            setSearchName(value);
            setSearchParams(prevState => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        const newSize = Number(event.target.value, 10);
        setRowsPerPage(newSize);
        setPage(1);
    };

    useEffect(() => { //사용자 디테일 정보 불러오기
        if (detailOpen | registerOpen) getMemberDetailInfo(selectedMemberId)
    }, [detailOpen, registerOpen])

    const getMemberDetailInfo = async (selectedMemberId) => {
        try {
            const response = await axios.get(`${common.getApiUrl()}/admin/member/${selectedMemberId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.data) {
                const data = response.data;

                const modifyData = {
                    memberId: data.memberId,
                    memberNm: data.memberNm,
                    topDeptId: Array.isArray(data.dept) && data.dept[0] ? String(data.dept[0].deptId) : "",
                    topDeptNm: Array.isArray(data.dept) && data.dept[0] ? data.dept[0].deptNm : "",
                    midDeptId: Array.isArray(data.dept) && data.dept[1] ? String(data.dept[1].deptId) : "",
                    midDeptNm: Array.isArray(data.dept) && data.dept[1] ? data.dept[1].deptNm : "",
                    botDeptId: Array.isArray(data.dept) && data.dept[2] ? String(data.dept[2].deptId) : "",
                    botDeptNm: Array.isArray(data.dept) && data.dept[2] ? data.dept[2].deptNm : "",
                    lastDeptLevel: data.lastDeptLevel || 3,
                    lastDeptId: Array.isArray(data.dept) && data.dept.length > 0 ? String(data.dept[data.dept.length - 1].deptId) : "",
                    role: data.role === 'INIT' ? '' : data.role,
                    roleNm: data.roleNm,
                    orgPosition: data.orgPosition ? String(data.orgPosition) : "0",
                    phone: data.phone,
                    email: data.email,
                    position: data.position === null ? '' : data.position,
                    imgSrc: data.imgSrc || '',
                };
                setDetailMemberInfo(modifyData);
            }

        } catch (error) {
            console.error("상세 정보를 가져오는 데 실패했습니다:", error);
        }
    }

    const clickPWInit = () => {
        setIsPwInitAlertOpen(true);
    };

    const handlePwInitAlertClose = () => {
        setIsPwInitAlertOpen(false);
    };

    const pwInit = async () => {
        try {
            const response = await axios.put(`${common.getApiUrl()}/admin/password-init?memberId=${selectedMemberId}`, {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                }
            );
            if (response.data) {
                handlePwInitAlertClose();
            }
        } catch (error) {
            console.error("비밀번호 초기화에 실패했습니다:", error);
        }
    }

    //모달 close, state 초기화
    useEffect(() => {
        if (!detailOpen && !registerOpen) {
            setDetailMemberInfo({});
            setSelectedMemberId(null);
        }
    }, [detailOpen, registerOpen]);

    const saveMemberDetailInfo = async () => {

        const params = {
            memberId: detailMemberInfo.memberId,
            memberNm: detailMemberInfo.memberNm,
            phone: detailMemberInfo.phone,
            email: detailMemberInfo.email,
            lastDeptId: Number(detailMemberInfo.lastDeptId),
            lastDeptLevel: detailMemberInfo.lastDeptLevel ? Number(detailMemberInfo.lastDeptLevel) : 0,
            position: detailMemberInfo.position,
            role: detailMemberInfo.role,
            orgPosition: detailMemberInfo.lastDeptLevel ? Number(detailMemberInfo.lastDeptLevel) : 0,
        };

        try {
            await axios.put(`${common.getApiUrl()}/admin/member`, params, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            setIsSave(true);
            setError('');
            handleDetailClose();
            handleRegisterClose();
        } catch (error) {
            if (error.response && error.response.data) {
                setError(error.response.data.message);
            } else {
                setError('An unexpected error occurred.');
            }
        }
    };

    const handleSearch = () => {
        setIsSearch(true)
        setPage(1);
    };

    const handleRegisterOpen = (memberId) => {
        setSelectedMemberId(memberId);
        setRegisterOpen(true);
    };

    const handleRegisterClose = () => {
        setRegisterOpen(false);
        setActiveStep(0);
        setError('')
    };

    const handleNextStepRegiForm = () => {
        if (activeStep === 0) {
            if (!detailMemberInfo.memberNm) {
                setError('이름은 필수값입니다.')
                return;
            }
            else {
                setActiveStep(1);
                setError('')
            }
        }
        else {
            setActiveStep(0);
            setError('')
        }
    };

    const handleDetailOpen = (memberId) => {
        setSelectedMemberId(memberId);
        setDetailOpen(true);
    };

    const handleDetailClose = () => {
        setDetailOpen(false);
        setError('')
    };

    const handleDetailSave = () => {
        if (!detailMemberInfo.role) {
            setError('사용 권한은 필수값입니다.');
            return;
        }

        // 관리처 선택 검사
        if (detailMemberInfo.role !== 'ADMIN') {
            if (detailMemberInfo.lastDeptLevel === 1) {
                setDetailMemberInfo(prevState => ({
                    ...prevState,
                    midDetpId: '',
                    midDetpNm: '',
                    botDetpId: '',
                    botDetpNm: '',
                }));
                if (!detailMemberInfo.topDeptId) {
                    setError('관리본부를 선택해주세요.');
                    return;
                }
            } else if (detailMemberInfo.lastDeptLevel === 2) {
                setDetailMemberInfo(prevState => ({
                    ...prevState,
                    botDetpId: '',
                    botDetpNm: '',
                }));
                if (!detailMemberInfo.topDeptId) {
                    setError('관리본부를 선택해주세요.');
                    return;
                }
                if (!detailMemberInfo.midDeptId) {
                    setError('관리부서를 선택해주세요.');
                    return;
                }
            } else if (detailMemberInfo.lastDeptLevel === 0 || detailMemberInfo.lastDeptLevel === 3) {
                if (!detailMemberInfo.topDeptId) {
                    setError('관리본부를 선택해주세요.');
                    return;
                }
                if (!detailMemberInfo.midDeptId) {
                    setError('관리부서를 선택해주세요.');
                    return;
                }
                if (!detailMemberInfo.botDeptId) {
                    setError('팀을 선택해주세요.');
                    return;
                }
            }
        }
        saveMemberDetailInfo();
    };

    const handleMemberDelete = () => {
        setIsMemDelAlertOpen(true);
    };

    //사용자 삭제
    const deleteMember = async () => {
        try {
            const response = await axios.delete(`${common.getApiUrl()}/admin/member/${selectedMemberId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            if (response) {
                setIsMemDelAlertOpen(false);
                setDetailOpen(false);
                setIsSave(true);
            }

        } catch (error) {
            console.error("사용자 삭제에 실패했습니다:", error);
        }
    }

    const handleMemDelAlertClose = () => setIsMemDelAlertOpen(false);

    const handleSelectedMemberInfoChange = (event) => {
        setError('')
        const { name, value } = event.target;
        switch (name) {
            case 'role':
                setDetailMemberInfo(prevState => ({
                    ...prevState,
                    role: value,
                    topDeptId: '',
                    topDeptNm: '',
                    midDeptId: '',
                    midDeptNm: '',
                    botDeptId: '',
                    botDeptNm: '',
                }));
                break;
            case 'orgPosition':
                setDetailMemberInfo(prevState => ({
                    ...prevState,
                    orgPosition: value,
                    topDeptId: '',
                    topDeptNm: '',
                    midDeptId: '',
                    midDeptNm: '',
                    botDeptId: '',
                    botDeptNm: '',
                    ...(value === '1' || value === '2' || value === '3' ? { lastDeptLevel: Number(value) } : {}),
                    ...(value === '0' ? { lastDeptLevel: 3 } : {})
                }));
                break;
            case 'topDeptId':
                const topDeptNm = deptList.find(item => item.deptId === value)?.deptNm;
                setDetailMemberInfo(prevState => ({
                    ...prevState,
                    topDeptId: value,
                    topDeptNm: topDeptNm,
                    midDeptId: '',
                    midDeptNm: '',
                    botDeptId: '',
                    botDeptNm: '',
                    lastDeptId: value,
                }));
                break;
            case 'midDeptId':
                const midDeptNm = deptList.find(item => item.deptId === value)?.deptNm;
                setDetailMemberInfo(prevState => ({
                    ...prevState,
                    midDeptId: value,
                    midDeptNm: midDeptNm,
                    botDeptId: '',
                    botDeptNm: '',
                    lastDeptId: value,
                }));
                break;
            case 'botDeptId':
                const botDeptNm = deptList.find(item => item.deptId === value)?.deptNm;
                setDetailMemberInfo(prevState => ({
                    ...prevState,
                    botDeptId: value,
                    botDeptNm: botDeptNm,
                    lastDeptId: value,
                }));
                break;
            case 'position':
                setDetailMemberInfo(prevState => ({
                    ...prevState,
                    position: value,
                }));
                break;
            default:
                break;
        }
    };

    //text field 값은 따로 관리
    const handleMemberInfoChange = (event) => {
        const { name, value } = event.target;

        setDetailMemberInfo(prevState => {
            // 전화번호 필드의 경우: 숫자만 남기기
            const phoneNormalize = name === 'phone' ? value.replace(/\D/g, '') : value;
            // 이름 필드의 경우: 앞뒤 공백 제거
            const normalizedValue = name === 'memberNm' ? value.trim() : phoneNormalize;

            return {
                ...prevState,
                [name]: normalizedValue
            };
        });
    };

    // 모바일용 카드 컴포넌트 - 개선된 버전
    const MobileCard = ({ member }) => (
        <Card sx={{
            mb: 0.75,
            boxShadow: 'none',
            border: '1px solid #e0e0e0',
            borderRadius: '6px',
            overflow: 'hidden',
            backgroundColor: '#ffffff'
        }}>
            <CardContent sx={{
                p: 1.5,
                '&:last-child': { pb: 1.5 }
            }}>
                {/* 상단: 이름, 역할, 액션 버튼 */}
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    mb: 1
                }}>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                fontWeight: 'bold',
                                fontSize: '1rem',
                                mb: 0.5,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                color: '#1976d2'
                            }}
                        >
                            {member.memberNm}
                        </Typography>
                        <Chip
                            label={member.roleNm}
                            size="small"
                            color={member.roleNm === '초기사용자' ? 'warning' : 'primary'}
                            variant={member.roleNm === '초기사용자' ? 'filled' : 'outlined'}
                            sx={{
                                fontSize: '0.7rem',
                                height: '20px',
                                fontWeight: 'medium'
                            }}
                        />
                    </Box>

                    {/* 액션 버튼 */}
                    <Box sx={{ ml: 1.5, flexShrink: 0 }}>
                        {member.roleNm === '초기사용자' ? (
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<PersonIcon sx={{ fontSize: '14px' }} />}
                                onClick={() => handleRegisterOpen(member.memberId)}
                                sx={{
                                    fontSize: '0.7rem',
                                    py: 0.5,
                                    px: 1,
                                    textTransform: 'none',
                                    borderRadius: '4px',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        boxShadow: 'none'
                                    }
                                }}
                            >
                                등록
                            </Button>
                        ) : (
                            <Button
                                variant="outlined"
                                color="primary"
                                size="small"
                                startIcon={<EditIcon sx={{ fontSize: '14px' }} />}
                                onClick={() => handleDetailOpen(member.memberId)}
                                sx={{
                                    fontSize: '0.7rem',
                                    py: 0.5,
                                    px: 1,
                                    textTransform: 'none',
                                    borderRadius: '4px'
                                }}
                            >
                                수정
                            </Button>
                        )}
                    </Box>
                </Box>

                {/* 상세 정보 섹션 */}
                <Stack spacing={0.5} sx={{ mt: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: 'medium',
                                color: 'text.secondary',
                                minWidth: '50px',
                                mr: 1,
                                fontSize: '0.75rem'
                            }}
                        >
                            ID:
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                flex: 1,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                fontSize: '0.75rem'
                            }}
                        >
                            {member.memberId || '-'}
                        </Typography>
                    </Box>

                    {member.email && (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    fontWeight: 'medium',
                                    color: 'text.secondary',
                                    minWidth: '50px',
                                    mr: 1,
                                    fontSize: '0.75rem'
                                }}
                            >
                                이메일:
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    flex: 1,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontSize: '0.75rem'
                                }}
                            >
                                {member.email}
                            </Typography>
                        </Box>
                    )}

                    {member.phone && (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    fontWeight: 'medium',
                                    color: 'text.secondary',
                                    minWidth: '50px',
                                    mr: 1,
                                    fontSize: '0.75rem'
                                }}
                            >
                                연락처:
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    flex: 1,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontSize: '0.75rem'
                                }}
                            >
                                {member.phone}
                            </Typography>
                        </Box>
                    )}

                    {member.deptNm && (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    fontWeight: 'medium',
                                    color: 'text.secondary',
                                    minWidth: '50px',
                                    mr: 1,
                                    fontSize: '0.75rem'
                                }}
                            >
                                부서:
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    flex: 1,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontSize: '0.75rem'
                                }}
                            >
                                {member.deptNm}
                            </Typography>
                        </Box>
                    )}
                </Stack>
            </CardContent>
        </Card>
    );

    // 데스크톱 테이블 컴포넌트
    const DesktopTable = () => (
        <TableContainer sx={{
            width: '100%',
            maxWidth: '100%',
            overflow: 'auto',
            boxSizing: 'border-box'
        }}>
            <Table stickyHeader sx={{
                tableLayout: 'fixed',
                width: '100%',
                minWidth: '800px' // 최소 너비 증가
            }}>
                <TableHead sx={{ backgroundColor: '#fff', }}>
                    <TableRow sx={{ height: '56px' }}> {/* 헤더 높이 증가 */}
                        <TableCell sx={{
                            padding: '16px 12px', // 패딩 증가
                            fontWeight: 'bold',
                            width: '120px',
                            fontSize: '0.875rem'
                        }}>역할</TableCell>
                        <TableCell sx={{
                            padding: '16px 12px',
                            fontWeight: 'bold',
                            width: '140px',
                            fontSize: '0.875rem'
                        }}>사용자 ID</TableCell>
                        <TableCell sx={{
                            padding: '16px 12px',
                            fontWeight: 'bold',
                            width: '150px',
                            fontSize: '0.875rem'
                        }}>이름</TableCell>
                        <TableCell sx={{
                            padding: '16px 12px',
                            fontWeight: 'bold',
                            width: '250px',
                            fontSize: '0.875rem'
                        }}>이메일</TableCell>
                        <TableCell sx={{
                            padding: '16px 12px',
                            fontWeight: 'bold',
                            width: '140px',
                            fontSize: '0.875rem'
                        }}>연락처</TableCell>
                        <TableCell sx={{
                            padding: '16px 12px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            width: '100px',
                            fontSize: '0.875rem'
                        }}>수정</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody sx={{ backgroundColor: '#fff' }}>
                    {Object.values(memberList)
                        .map((member, index) => (
                            <TableRow
                                key={member.id || index}
                                sx={{
                                    height: '64px', // 행 높이 증가 (기존 24px -> 64px)
                                    '&:hover': {
                                        backgroundColor: '#f5f5f5'
                                    }
                                }}
                            >
                                <TableCell sx={{
                                    padding: '16px 12px', // 패딩 증가
                                    color: 'rgb(33, 33, 33)', // 텍스트 색상 진하게
                                    fontSize: '0.875rem',
                                    maxWidth: '120px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }}>{member.roleNm}</TableCell>
                                <TableCell sx={{
                                    padding: '16px 12px',
                                    color: 'rgb(33, 33, 33)',
                                    fontSize: '0.875rem',
                                    maxWidth: '140px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }}>{member.memberId}</TableCell>
                                <TableCell sx={{
                                    padding: '16px 12px',
                                    color: 'rgb(33, 33, 33)',
                                    fontSize: '0.875rem',
                                    fontWeight: '500', // 이름 강조
                                    maxWidth: '150px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }}>{member.memberNm}</TableCell>
                                <TableCell sx={{
                                    padding: '16px 12px',
                                    color: 'rgb(33, 33, 33)',
                                    fontSize: '0.875rem',
                                    maxWidth: '250px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }}>{member.email}</TableCell>
                                <TableCell sx={{
                                    padding: '16px 12px',
                                    color: 'rgb(33, 33, 33)',
                                    fontSize: '0.875rem',
                                    maxWidth: '140px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }}>{member.phone}</TableCell>
                                <TableCell sx={{
                                    padding: '16px 12px',
                                }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        {member.roleNm === '초기사용자' ? (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                onClick={() => handleRegisterOpen(member.memberId)}
                                                sx={{
                                                    fontSize: '0.75rem',
                                                    py: 0.5,
                                                    px: 1.5,
                                                    textTransform: 'none',
                                                    borderRadius: '4px'
                                                }}
                                            >
                                                정보 등록
                                            </Button>
                                        ) : (
                                            <IconButton
                                                onClick={() => handleDetailOpen(member.memberId)}
                                                color="primary"
                                                size="small"
                                                sx={{
                                                    padding: '8px',
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(25, 118, 210, 0.04)'
                                                    }
                                                }}
                                            >
                                                <SearchIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    {/* 빈 행들도 높이 조정 */}
                    {Array.from({ length: Math.max(0, rowsPerPage - memberList.length) }).map((_, index) => (
                        <TableRow key={`empty-row-${index}`} sx={{ height: '64px' }}>
                            <TableCell colSpan={6} sx={{ padding: '16px 12px', border: 'none' }} />
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );

    return (
        <Box sx={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            boxSizing: 'border-box',
            ...(isMobile ? {
                px: 0,
                mx: 0,
                height: '100vh',
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: '#f5f5f5'
            } : {
                mx: -3,
                px: 3
            })
        }}>
            <Paper sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                boxSizing: 'border-box',
                ...(isMobile ? {
                    borderRadius: 0,
                    boxShadow: 'none',
                    backgroundColor: '#ffffff'
                } : {})
            }}>
                {/* 헤더 영역 - 고정 */}
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexShrink: 0,
                    backgroundColor: '#ffffff',
                    borderBottom: '1px solid #e0e0e0',
                    zIndex: 10,
                    ...(isMobile ? {
                        px: 2,
                        py: 1.5,
                        minHeight: '64px',
                        marginTop: '55px'
                    } : {
                        p: 3,
                        pb: 2
                    })
                }}>
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 'bold',
                            fontSize: isMobile ? '1.3rem' : '1.5rem',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            color: '#1976d2'
                        }}
                    >
                        사용자 설정
                    </Typography>

                    {/* 모바일에서만 검색 토글 버튼 표시 */}
                    {isMobile && (
                        <Button
                            variant="outlined"
                            size="small"
                            startIcon={<FilterListIcon />}
                            endIcon={isSearchOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            onClick={() => setIsSearchOpen(!isSearchOpen)}
                            sx={{
                                fontSize: '0.8rem',
                                py: 0.75,
                                px: 1.5,
                                minHeight: '36px',
                                textTransform: 'none',
                                borderRadius: '8px'
                            }}
                        >
                            검색
                        </Button>
                    )}
                </Box>

                {/* 검색 영역 - 조건부 표시 */}
                <Box sx={{
                    flexShrink: 0,
                    backgroundColor: '#ffffff',
                    ...(isMobile && {
                        borderBottom: isSearchOpen ? '1px solid #e0e0e0' : 'none'
                    })
                }}>
                    {isMobile ? (
                        <Collapse in={isSearchOpen} timeout="auto" unmountOnExit>
                            <Box sx={{
                                p: 2,
                                backgroundColor: '#f8f9fa',
                                borderBottom: '1px solid #e0e0e0'
                            }}>
                                <Stack spacing={2}>
                                    <FormControl size="small" fullWidth>
                                        <InputLabel sx={{ fontSize: '0.9rem' }}>구분</InputLabel>
                                        <Select
                                            value={searchRole}
                                            label="구분"
                                            onChange={(e) => handleSearchChanges('role', e.target.value)}
                                            sx={{
                                                fontSize: '0.9rem',
                                                backgroundColor: '#ffffff'
                                            }}
                                        >
                                            {roleList.map((role) => (
                                                <MenuItem key={role.value} value={role.value} sx={{ fontSize: '0.9rem' }}>
                                                    {role.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    <TextField
                                        size="small"
                                        fullWidth
                                        label="사용자명"
                                        value={searchName}
                                        onChange={(e) => handleSearchChanges('memberNm', e.target.value)}
                                        sx={{
                                            '& .MuiInputLabel-root': { fontSize: '0.9rem' },
                                            '& .MuiOutlinedInput-root': {
                                                fontSize: '0.9rem',
                                                backgroundColor: '#ffffff'
                                            }
                                        }}
                                    />

                                    <Button
                                        variant="contained"
                                        fullWidth
                                        startIcon={<SearchIcon />}
                                        onClick={() => {
                                            handleSearch();
                                            setIsSearchOpen(false);
                                        }}
                                        sx={{
                                            fontSize: '0.9rem',
                                            py: 1,
                                            textTransform: 'none',
                                            borderRadius: '8px',
                                            boxShadow: 'none',
                                            '&:hover': {
                                                boxShadow: 'none'
                                            }
                                        }}
                                    >
                                        검색
                                    </Button>
                                </Stack>
                            </Box>
                        </Collapse>
                    ) : (
                        <Box sx={{
                            px: 3,
                            pb: 1,
                            borderBottom: '1px solid #e0e0e0'
                        }}>
                            <SearchArea
                                searchValues={{ role: searchRole, memberNm: searchName }}
                                handleSearchChanges={(name, value) => { handleSearchChanges(name, value); }}
                                fields={[
                                    {
                                        fieldnm: '구분',
                                        name: 'role',
                                        type: 'select',
                                        options: roleList
                                    },
                                    {
                                        fieldnm: '사용자명',
                                        name: 'memberNm',
                                        type: 'input',
                                    }
                                ]}
                                onSearchClick={handleSearch}
                            />
                        </Box>
                    )}
                </Box>

                {/* 메인 콘텐츠 영역 - 스크롤 가능 */}
                <Box sx={{
                    flex: 1,
                    overflow: 'auto',
                    minHeight: 0,
                    backgroundColor: isMobile ? '#f5f5f5' : '#ffffff'
                }}>
                    {isMobile ? (
                        // 모바일 카드 뷰
                        <Box sx={{
                            p: 2,
                            height: '100%',
                            overflow: 'auto'
                        }}>
                            {Object.values(memberList).length > 0 ? (
                                Object.values(memberList).map((member, index) => (
                                    <MobileCard key={member.memberId || index} member={member} />
                                ))
                            ) : (
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minHeight: '300px',
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    boxShadow: 1
                                }}>
                                    <Typography
                                        color="text.secondary"
                                        sx={{
                                            fontSize: '1rem',
                                            textAlign: 'center'
                                        }}
                                    >
                                        검색 결과가 없습니다.
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    ) : (
                        // 데스크톱 테이블 뷰
                        <Box sx={{
                            px: 3,
                            height: '100%',
                            overflow: 'auto'
                        }}>
                            <DesktopTable />
                        </Box>
                    )}
                </Box>

                {/* 페이지네이션 - 하단 고정 */}
                <Box sx={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    position: 'relative',
                    backgroundColor: '#ffffff',
                    borderTop: '1px solid #e0e0e0',
                    ...(isMobile ? {
                        p: 2,
                        gap: 1
                    } : {
                        p: 3,
                        pt: 2
                    })
                }}>
                    <Pagination
                        count={Math.ceil(totalElements / rowsPerPage)}
                        page={page}
                        onChange={(event, newPage) => handleChangePage(event, newPage)}
                        showFirstButton
                        showLastButton
                        size={isMobile ? "medium" : "medium"}
                        sx={{
                            '& .MuiPaginationItem-root': {
                                fontSize: isMobile ? '0.9rem' : '1rem'
                            }
                        }}
                    />

                    {!isMobile && (
                        <Box sx={{ position: 'absolute', left: 24 }}>
                            <TablePagination
                                labelDisplayedRows={() => ''}
                                component="div"
                                page={page - 1}
                                count={totalElements}
                                rowsPerPageOptions={[10, 25, 50]}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleRowsPerPageChange}
                                ActionsComponent={() => null}
                                onPageChange={() => null}
                            />
                        </Box>
                    )}

                    {/* 모바일용 페이지 정보 표시 */}
                    {isMobile && (
                        <Typography
                            variant="caption"
                            sx={{
                                color: 'text.secondary',
                                fontSize: '0.8rem',
                                textAlign: 'center'
                            }}
                        >
                            전체 {totalElements}개 중 {((page - 1) * rowsPerPage) + 1}-{Math.min(page * rowsPerPage, totalElements)}개 표시
                        </Typography>
                    )}
                </Box>
            </Paper>

            {/* 사용자 수정/삭제 모달 - 모바일 최적화 */}
            <Dialog
                open={detailOpen}
                onClose={handleDetailClose}
                maxWidth="md"
                fullWidth
                fullScreen={isMobile}
                sx={{
                    '& .MuiDialog-paper': {
                        ...(isMobile ? {
                            margin: 0,
                            borderRadius: 0,
                            maxHeight: '100vh',
                            height: '100vh'
                        } : {
                            borderRadius: '12px'
                        })
                    }
                }}
            >
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: '#f8f9fa',
                    borderBottom: '1px solid #e0e0e0'
                }}>
                    <DialogTitle sx={{
                        fontSize: isMobile ? '1.2rem' : '1.4rem',
                        fontWeight: 'bold',
                        color: '#1976d2',
                        flex: 1
                    }}>
                        사용자 수정 / 삭제
                    </DialogTitle>
                    <IconButton
                        onClick={handleDetailClose}
                        sx={{
                            mr: 1,
                            backgroundColor: 'rgba(0,0,0,0.04)',
                            '&:hover': {
                                backgroundColor: 'rgba(0,0,0,0.08)'
                            }
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>

                <DialogContent sx={{
                    px: isMobile ? 2 : 3,
                    py: isMobile ? 2 : 3,
                    height: isMobile ? 'calc(100vh - 180px)' : 'auto',
                    overflow: 'auto'
                }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        gap: isMobile ? 3 : 4,
                        width: '100%'
                    }}>
                        {/* 기본 정보 섹션 */}
                        <Box sx={{
                            flex: isMobile ? 1 : 0.4,
                            backgroundColor: '#f8f9fa',
                            p: 2.5,
                            borderRadius: '8px',
                            border: '1px solid #e0e0e0'
                        }}>
                            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#1976d2' }}>
                                기본 정보
                            </Typography>

                            <Stack spacing={2.5}>
                                <FormControl variant="standard" fullWidth>
                                    <InputLabel shrink={true}>이름</InputLabel>
                                    <Input
                                        name="memberNm"
                                        value={detailMemberInfo.memberNm || ''}
                                        onChange={handleMemberInfoChange}
                                        sx={{ fontSize: '1rem' }}
                                    />
                                </FormControl>

                                <FormControl variant="standard" fullWidth>
                                    <InputLabel shrink={true}>연락처</InputLabel>
                                    <Input
                                        name='phone'
                                        value={detailMemberInfo.phone || ''}
                                        onChange={handleMemberInfoChange}
                                        sx={{ fontSize: '1rem' }}
                                    />
                                </FormControl>

                                <FormControl variant="standard" fullWidth>
                                    <InputLabel shrink={true}>이메일</InputLabel>
                                    <Input
                                        name='email'
                                        value={detailMemberInfo.email || ''}
                                        onChange={handleMemberInfoChange}
                                        sx={{ fontSize: '1rem' }}
                                    />
                                </FormControl>

                                <FormControl variant="standard" fullWidth>
                                    <InputLabel shrink={true}>아이디</InputLabel>
                                    <Input
                                        name='memberId'
                                        value={detailMemberInfo.memberId || ''}
                                        disabled
                                        sx={{
                                            fontSize: '1rem',
                                            '& .Mui-disabled': {
                                                color: 'rgba(0, 0, 0, 0.6)'
                                            }
                                        }}
                                    />
                                </FormControl>

                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: isMobile ? 'column' : 'row',
                                    alignItems: isMobile ? 'stretch' : 'center',
                                    gap: isMobile ? 1 : 2,
                                    mt: 1
                                }}>
                                    <Typography sx={{
                                        fontWeight: 'medium',
                                        color: 'text.secondary'
                                    }}>
                                        비밀번호 초기화
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        color="warning"
                                        onClick={clickPWInit}
                                        size={isMobile ? "medium" : "small"}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '6px'
                                        }}
                                    >
                                        초기화
                                    </Button>
                                </Box>
                            </Stack>
                        </Box>

                        {/* 권한 및 조직 정보 섹션 */}
                        <Box sx={{
                            flex: isMobile ? 1 : 0.6,
                            backgroundColor: '#f8f9fa',
                            p: 2.5,
                            borderRadius: '8px',
                            border: '1px solid #e0e0e0'
                        }}>
                            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#1976d2' }}>
                                권한 및 조직 정보
                            </Typography>

                            <Stack spacing={2.5}>
                                <FormControl size="small" fullWidth>
                                    <InputLabel>사용 권한</InputLabel>
                                    <Select
                                        name='role'
                                        label="사용 권한"
                                        value={detailMemberInfo.role || ''}
                                        onChange={handleSelectedMemberInfoChange}
                                        disabled
                                        sx={{ backgroundColor: '#ffffff' }}
                                    >
                                        {roleList.slice(1, -1).map((role) => (
                                            <MenuItem key={role.value} value={role.value}>{role.label}</MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText sx={{ color: 'warning.main' }}>
                                        *사용 권한은 수정할 수 없습니다.
                                    </FormHelperText>
                                </FormControl>

                                {detailMemberInfo.role === 'MANAGE' && (
                                    <FormControl size="small" fullWidth>
                                        <InputLabel>관리 포지션</InputLabel>
                                        <Select
                                            name='orgPosition'
                                            label="관리 포지션"
                                            value={detailMemberInfo.orgPosition || '0'}
                                            onChange={handleSelectedMemberInfoChange}
                                            sx={{ backgroundColor: '#ffffff' }}
                                        >
                                            {orgPosition.map((item) => (
                                                <MenuItem key={item.position} value={item.position}>
                                                    {item.positionNm}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}

                                {detailMemberInfo.role !== '' && detailMemberInfo.role !== 'ADMIN' && (
                                    <Stack spacing={2}>
                                        <FormControl size="small" fullWidth>
                                            <InputLabel>관리본부</InputLabel>
                                            <Select
                                                name='topDeptId'
                                                label="관리본부"
                                                value={detailMemberInfo.topDeptId || ''}
                                                onChange={handleSelectedMemberInfoChange}
                                                sx={{ backgroundColor: '#ffffff' }}
                                            >
                                                {deptList.filter(dept => dept.deptLevel === 1).map((item) => (
                                                    <MenuItem key={item.deptId} value={item.deptId}>
                                                        {item.deptNm}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        {(detailMemberInfo.orgPosition === '0' || detailMemberInfo.orgPosition === '2' || detailMemberInfo.orgPosition === '3') && (
                                            <FormControl size="small" fullWidth>
                                                <InputLabel>관리부서</InputLabel>
                                                <Select
                                                    name='midDeptId'
                                                    label="관리부서"
                                                    value={detailMemberInfo.midDeptId || ''}
                                                    onChange={handleSelectedMemberInfoChange}
                                                    disabled={!detailMemberInfo.topDeptId}
                                                    sx={{ backgroundColor: '#ffffff' }}
                                                >
                                                    {deptList.filter(dept => dept.deptLevel === 2 && dept.upperDept === Number(detailMemberInfo.topDeptId)).map((item) => (
                                                        <MenuItem key={item.deptId} value={item.deptId}>
                                                            {item.deptNm}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        )}

                                        {(detailMemberInfo.orgPosition === '0' || detailMemberInfo.orgPosition === '3') && (
                                            <FormControl size="small" fullWidth>
                                                <InputLabel>팀</InputLabel>
                                                <Select
                                                    name='botDeptId'
                                                    label="팀"
                                                    value={detailMemberInfo.botDeptId || ''}
                                                    onChange={handleSelectedMemberInfoChange}
                                                    disabled={!detailMemberInfo.midDeptId}
                                                    sx={{ backgroundColor: '#ffffff' }}
                                                >
                                                    {deptList.filter(dept => dept.deptLevel === 3 && dept.upperDept === Number(detailMemberInfo.midDeptId)).map((item) => (
                                                        <MenuItem key={item.deptId} value={item.deptId}>
                                                            {item.deptNm}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        )}
                                    </Stack>
                                )}

                                {detailMemberInfo.role !== 'ADMIN' && (
                                    <FormControl size="small" fullWidth>
                                        <InputLabel>직위</InputLabel>
                                        <Select
                                            name='position'
                                            label="직위"
                                            value={detailMemberInfo.position || ''}
                                            onChange={handleSelectedMemberInfoChange}
                                            sx={{ backgroundColor: '#ffffff' }}
                                        >
                                            {positionList.map((item, index) => (
                                                <MenuItem key={index} value={item.comDtlNm}>
                                                    {item.comDtlNm}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}
                            </Stack>
                        </Box>
                    </Box>

                    {error && (
                        <Alert severity="error" sx={{ mt: 3 }}>
                            {error}
                        </Alert>
                    )}
                </DialogContent>

                <DialogActions sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? 1.5 : 2,
                    p: isMobile ? 2 : 3,
                    backgroundColor: '#f8f9fa',
                    borderTop: '1px solid #e0e0e0'
                }}>
                    <Button
                        onClick={() => handleMemberDelete(detailMemberInfo.memberId)}
                        variant="outlined"
                        color="error"
                        fullWidth={isMobile}
                        size={isMobile ? "large" : "medium"}
                        sx={{
                            textTransform: 'none',
                            borderRadius: '8px',
                            py: isMobile ? 1.5 : 1
                        }}
                    >
                        사용자 삭제
                    </Button>
                    <Button
                        onClick={handleDetailSave}
                        variant="contained"
                        color="primary"
                        fullWidth={isMobile}
                        size={isMobile ? "large" : "medium"}
                        sx={{
                            textTransform: 'none',
                            borderRadius: '8px',
                            py: isMobile ? 1.5 : 1,
                            boxShadow: 2,
                            '&:hover': {
                                boxShadow: 3
                            }
                        }}
                    >
                        저장
                    </Button>
                </DialogActions>

                <AlertForConfirm
                    open={isPwInitAlertOpen}
                    onClose={handlePwInitAlertClose}
                    onConfirm={pwInit}
                    contentText="해당 사용자의 비밀번호를 초기화하시겠습니까?"
                    severity='warning'
                />

                <AlertForConfirm
                    open={isMemDelAlertOpen}
                    onClose={handleMemDelAlertClose}
                    onConfirm={deleteMember}
                    contentText="해당 사용자를 삭제하시겠습니까?"
                    severity='warning'
                />
            </Dialog>

            {/* 신규 사용자 정보 등록 모달 - 모바일 최적화 */}
            <Dialog
                open={registerOpen}
                onClose={handleRegisterClose}
                maxWidth="md"
                fullWidth
                fullScreen={isMobile}
                sx={{
                    '& .MuiDialog-paper': {
                        ...(isMobile ? {
                            margin: 0,
                            borderRadius: 0,
                            maxHeight: '100vh',
                            height: '100vh'
                        } : {
                            borderRadius: '12px'
                        })
                    }
                }}
            >
                <DialogTitle sx={{
                    fontSize: isMobile ? '1.2rem' : '1.4rem',
                    fontWeight: 'bold',
                    color: '#1976d2',
                    backgroundColor: '#f8f9fa',
                    borderBottom: '1px solid #e0e0e0'
                }}>
                    신규 사용자 정보 등록
                </DialogTitle>

                <DialogContent sx={{
                    px: isMobile ? 2 : 3,
                    py: isMobile ? 2 : 3,
                    height: isMobile ? 'calc(100vh - 180px)' : 'auto',
                    overflow: 'auto'
                }}>
                    <Stepper activeStep={activeStep} orientation="vertical" sx={{ mt: 1 }}>
                        <Step>
                            <StepLabel>
                                <Typography sx={{ fontWeight: 'bold' }}>기본 정보 입력</Typography>
                            </StepLabel>
                            {activeStep === 0 && (
                                <Alert severity="warning" sx={{ mb: 2, mt: 1 }}>
                                    기본 정보는 가입 시 사용자가 입력한 값입니다. 수정에 유의하세요.
                                </Alert>
                            )}
                            <StepContent>
                                <Box sx={{
                                    backgroundColor: '#f8f9fa',
                                    p: 2.5,
                                    borderRadius: '8px',
                                    border: '1px solid #e0e0e0',
                                    mt: 2
                                }}>
                                    <Stack spacing={2.5}>
                                        <FormControl variant="standard" fullWidth>
                                            <InputLabel shrink={true}>이름</InputLabel>
                                            <Input
                                                name='memberNm'
                                                value={detailMemberInfo.memberNm || ''}
                                                onChange={handleMemberInfoChange}
                                                sx={{ fontSize: '1rem' }}
                                            />
                                        </FormControl>

                                        <FormControl variant="standard" fullWidth>
                                            <InputLabel shrink={true}>연락처</InputLabel>
                                            <Input
                                                name='phone'
                                                value={detailMemberInfo.phone || ''}
                                                onChange={handleMemberInfoChange}
                                                sx={{ fontSize: '1rem' }}
                                            />
                                        </FormControl>

                                        <FormControl variant="standard" fullWidth>
                                            <InputLabel shrink={true}>이메일</InputLabel>
                                            <Input
                                                name='email'
                                                value={detailMemberInfo.email || ''}
                                                onChange={handleMemberInfoChange}
                                                sx={{ fontSize: '1rem' }}
                                            />
                                        </FormControl>

                                        <FormControl variant="standard" fullWidth>
                                            <InputLabel shrink={true}>아이디</InputLabel>
                                            <Input
                                                name='memberId'
                                                value={detailMemberInfo.memberId || ''}
                                                disabled
                                                sx={{
                                                    fontSize: '1rem',
                                                    '& .Mui-disabled': {
                                                        color: 'rgba(0, 0, 0, 0.6)'
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </Stack>
                                </Box>

                                {error && (
                                    <Alert severity="error" sx={{ mt: 2 }}>
                                        {error}
                                    </Alert>
                                )}

                                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-start' }}>
                                    <Button
                                        onClick={handleNextStepRegiForm}
                                        variant="contained"
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '8px',
                                            px: 3,
                                            py: 1
                                        }}
                                    >
                                        다음
                                    </Button>
                                </Box>
                            </StepContent>
                        </Step>

                        <Step>
                            <StepLabel>
                                <Typography sx={{ fontWeight: 'bold' }}>권한 및 조직 선택</Typography>
                            </StepLabel>
                            <StepContent>
                                <Box sx={{
                                    backgroundColor: '#f8f9fa',
                                    p: 2.5,
                                    borderRadius: '8px',
                                    border: '1px solid #e0e0e0',
                                    mt: 2
                                }}>
                                    <Stack spacing={2.5}>
                                        <FormControl size="small" fullWidth required>
                                            <InputLabel>사용 권한</InputLabel>
                                            <Select
                                                name='role'
                                                label="사용 권한"
                                                value={detailMemberInfo.role || ''}
                                                onChange={handleSelectedMemberInfoChange}
                                                sx={{ backgroundColor: '#ffffff' }}
                                            >
                                                {roleList.slice(1, -1).map((role) => (
                                                    <MenuItem key={role.value} value={role.value}>{role.label}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        {detailMemberInfo.role === 'MANAGE' && (
                                            <>
                                                <Divider sx={{ my: 1 }} />
                                                <FormControl size="small" fullWidth required>
                                                    <InputLabel>관리 포지션</InputLabel>
                                                    <Select
                                                        name='orgPosition'
                                                        label="관리 포지션"
                                                        value={detailMemberInfo.orgPosition || ''}
                                                        onChange={handleSelectedMemberInfoChange}
                                                        sx={{ backgroundColor: '#ffffff' }}
                                                    >
                                                        {orgPosition.map((item) => (
                                                            <MenuItem key={item.position} value={item.position}>
                                                                {item.positionNm}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </>
                                        )}

                                        {detailMemberInfo.role !== "" && detailMemberInfo.role !== 'ADMIN' && (
                                            <Stack spacing={2}>
                                                <FormControl size="small" fullWidth>
                                                    <InputLabel>관리본부</InputLabel>
                                                    <Select
                                                        name='topDeptId'
                                                        label="관리본부"
                                                        value={detailMemberInfo.topDeptId || ''}
                                                        onChange={handleSelectedMemberInfoChange}
                                                        sx={{ backgroundColor: '#ffffff' }}
                                                    >
                                                        {deptList.filter(dept => dept.deptLevel === 1).map((item) => (
                                                            <MenuItem key={item.deptId} value={item.deptId}>
                                                                {item.deptNm}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                    {(detailMemberInfo.orgPosition !== '1') && (
                                                        <FormHelperText>상위 조직부터 순서대로 선택하세요</FormHelperText>
                                                    )}
                                                </FormControl>

                                                {(detailMemberInfo.orgPosition === '0' || detailMemberInfo.orgPosition === '2' || detailMemberInfo.orgPosition === '3') && (
                                                    <FormControl size="small" fullWidth>
                                                        <InputLabel>관리부서</InputLabel>
                                                        <Select
                                                            name='midDeptId'
                                                            label="관리부서"
                                                            value={detailMemberInfo.midDeptId || ''}
                                                            onChange={handleSelectedMemberInfoChange}
                                                            disabled={!detailMemberInfo.topDeptId}
                                                            sx={{ backgroundColor: '#ffffff' }}
                                                        >
                                                            {deptList.filter(dept => dept.deptLevel === 2 && dept.upperDept === Number(detailMemberInfo.topDeptId)).map((item) => (
                                                                <MenuItem key={item.deptId} value={item.deptId}>
                                                                    {item.deptNm}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                )}

                                                {(detailMemberInfo.orgPosition === '0' || detailMemberInfo.orgPosition === '3') && (
                                                    <FormControl size="small" fullWidth>
                                                        <InputLabel>팀</InputLabel>
                                                        <Select
                                                            name='botDeptId'
                                                            label="팀"
                                                            value={detailMemberInfo.botDeptId || ''}
                                                            onChange={handleSelectedMemberInfoChange}
                                                            disabled={!detailMemberInfo.midDeptId}
                                                            sx={{ backgroundColor: '#ffffff' }}
                                                        >
                                                            {deptList.filter(dept => dept.deptLevel === 3 && dept.upperDept === Number(detailMemberInfo.midDeptId)).map((item) => (
                                                                <MenuItem key={item.deptId} value={item.deptId}>
                                                                    {item.deptNm}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                )}
                                            </Stack>
                                        )}

                                        <Divider sx={{ my: 1 }} />

                                        {detailMemberInfo.role !== 'ADMIN' && (
                                            <FormControl size="small" fullWidth>
                                                <InputLabel>직위</InputLabel>
                                                <Select
                                                    name='position'
                                                    label="직위"
                                                    value={detailMemberInfo.position || ''}
                                                    onChange={handleSelectedMemberInfoChange}
                                                    sx={{ backgroundColor: '#ffffff' }}
                                                >
                                                    {positionList.map((item, index) => (
                                                        <MenuItem key={index} value={item.comDtlNm}>
                                                            {item.comDtlNm}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        )}
                                    </Stack>
                                </Box>

                                {error && (
                                    <Alert severity="error" sx={{ mt: 2 }}>
                                        {error}
                                    </Alert>
                                )}

                                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-start' }}>
                                    <Button
                                        onClick={handleNextStepRegiForm}
                                        variant="outlined"
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '8px',
                                            px: 3,
                                            py: 1
                                        }}
                                    >
                                        이전
                                    </Button>
                                </Box>
                            </StepContent>
                        </Step>
                    </Stepper>
                </DialogContent>

                <DialogActions sx={{
                    justifyContent: 'space-between',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? 1.5 : 2,
                    p: isMobile ? 2 : 3,
                    backgroundColor: '#f8f9fa',
                    borderTop: '1px solid #e0e0e0'
                }}>
                    <Button
                        onClick={handleRegisterClose}
                        variant="outlined"
                        color="error"
                        fullWidth={isMobile}
                        size={isMobile ? "large" : "medium"}
                        sx={{
                            textTransform: 'none',
                            borderRadius: '8px',
                            py: isMobile ? 1.5 : 1
                        }}
                    >
                        취소
                    </Button>
                    <Button
                        onClick={handleDetailSave}
                        variant="contained"
                        color="primary"
                        disabled={activeStep < 1}
                        fullWidth={isMobile}
                        size={isMobile ? "large" : "medium"}
                        sx={{
                            textTransform: 'none',
                            borderRadius: '8px',
                            py: isMobile ? 1.5 : 1,
                            boxShadow: 2,
                            '&:hover': {
                                boxShadow: 3
                            }
                        }}
                    >
                        저장
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

export default validationAuth(MemberManagement);